import { render, staticRenderFns } from "./EmailDeliveryDeleteDialog.vue?vue&type=template&id=4ae21a7e"
import script from "./EmailDeliveryDeleteDialog.vue?vue&type=script&lang=js"
export * from "./EmailDeliveryDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports